export { Stack } from "@mantine/core";
export type { StackProps } from "@mantine/core";
